import { apiService } from "../api";

export interface DashboardStatistics {
  totals: {
    products: number;
    categories: number;
    orders: number;
    revenue: number;
  };
  orders: {
    byStatus: {
      new: number;
      confirmed: number;
      preparing: number;
      shipped: number;
      canceled: number;
    };
    last7Days: number;
    last30Days: number;
  };
  revenue: {
    total: number;
    last7Days: number;
    last30Days: number;
    thisMonth: number;
  };
  charts: {
    ordersOverTime: Array<{
      date: string;
      count: number;
    }>;
    revenueOverTime: Array<{
      date: string;
      revenue: number;
    }>;
    ordersByProduct: Array<{
      productName: string;
      count: number;
    }>;
  };
  recentOrders: Array<{
    id: string;
    orderNumber: string;
    customerName: string;
    productName: string;
    finalPrice: number;
    status: string;
    createdAt: string;
  }>;
}

export const dashboardService = {
  getStatistics: async (): Promise<DashboardStatistics> => {
    return await apiService.get<DashboardStatistics>("/admin/dashboard/statistics");
  },
};

